<template>
    <div class="bg-white px-3" style="margin-bottom: 0!important;">
        <div ref="titles">
            <el-form ref="levelFrom" :model="formValidate" @submit.native.prevent :inline="true"
                class="form-inlines u-f  u-jsb">
                <div>
                    <el-form-item label="公众号：">
                        <el-select v-model="gzh_value" size="small" placeholder="请选择" @change="changegzh">
                            <el-option v-for="item in gzh_options" :key="item.source" :label="item.name"
                                :value="item.source">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <!-- <el-form-item label="回复类型：" prop="type" label-for="type">
                        <el-select v-model="formValidate.type" placeholder="请选择" clearable @on-change="begin"
                            size="small">
                            <el-option value="text" label="文字消息">文字消息</el-option>
                            <el-option value="image" label="图片消息">图片消息</el-option>
                            <el-option value="news" label="图文消息">图文消息</el-option>
                            <el-option value="voice" label="声音消息">声音消息</el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item label="关键字：" prop="key">
                        <el-input search enter-button v-model="formValidate.key" size="small" placeholder="请输入关键字" />
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" @click="begin" size="small"></el-button>
                    </el-form-item>
                </div>
                <el-form-item>
                    <el-button type="primary" @click="add" size="small">添加关键字</el-button>
                </el-form-item>
            </el-form>
        </div>
        <el-table :data="tabList" ref="table" class="mt25" border v-loading="loading" :height="heights">
            <el-table-column label="关键字" prop="keys"></el-table-column>
            <el-table-column label="回复类型" prop="type">
                <template slot-scope="{row}">
                    {{({'text':'文字消息','image':'图片消息','news':'文章消息','sketch':'图文消息','myqrcode':'任务宝'})[row.type]}}
                </template>
            </el-table-column>
            <el-table-column label="是否显示">
                <template slot-scope="{ row, index }">
                    <el-switch v-model="row.status" active-text="开启" inactive-text="关闭" active-value="0"
                        inactive-value="1" @change="onchangeIsShow(row,index)" size="small"></el-switch>
                </template>
            </el-table-column>
            <el-table-column label="时间" prop="create_time"></el-table-column>
            <el-table-column label="优惠券" width="80">
                <template slot-scope="{ row }">
                    <el-button type="text" @click="setUp(row)" size="small">设置</el-button>
                </template>
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="{ row, index }">
                    <el-button type="primary" @click="edit(row)" size='small'>编辑</el-button>
                    <el-button type="danger" @click="del(row,index)" size='small'>删除</el-button>
                </template>
            </el-table-column>

        </el-table>
        <div class="u-f u-ac u-jsb ft_mr">
            <div></div>
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="formValidate.page" :page-sizes="[15, 30, 50, 100]" :page-size="formValidate.limit"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>


        <el-dialog title="设置关键字" center :visible.sync="dialog_edit" width="40%" top="100px" class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content" v-loading='openeditloading'>
                <el-form ref="editformValidate" :model="editformValidate" :rules="ruleValidate" class="form-inlines"
                    label-width="100px">
                    <el-form-item label="关键字：" prop="name">
                        <el-input v-model="editformValidate.name" style="max-width:500px" size="small"
                            placeholder="请输入关键字" />
                    </el-form-item>
                    <el-form-item label="信息状态：">
                        <el-radio-group v-model="editformValidate.status">
                            <el-radio :label="0">启用</el-radio>
                            <el-radio :label="1">禁用</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="信息类型：" prop="type" label-for="type">
                        <el-select v-model="editformValidate.type" placeholder="请选择" size="small" @change="changetype">
                            <el-option value="text" label="文字消息">文字消息</el-option>
                            <el-option value="image" label="图片消息">图片消息</el-option>
                            <el-option value="news" label="文章消息">文章消息</el-option>
                            <el-option value="sketch" label="图文消息">图文消息</el-option>
                            <el-option value="myqrcode" label="任务宝">任务宝</el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="消息内容：" prop="content" v-if="editformValidate.type == 'text'">
                        <el-input v-model="editformValidate.content" placeholder="请填写消息内容" type="textarea"
                            style="max-width:500px" :rows="4" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="图片" prop="image_url"
                        v-if="editformValidate.type == 'image'||editformValidate.type == 'sketch'">
                        <span v-if="!editformValidate.image_url" class="btn btn-light border mr-2"
                            @click="pos_chooseImage">
                            <i class="el-icon-plus"></i>
                        </span>
                        <img v-else :src="editformValidate.image_url" class="rounded"
                            style="width: 45px;height: 45px;cursor: pointer;" @click="pos_chooseImage" />
                    </el-form-item>
                    <el-form-item label="图文：" v-if="editformValidate.type == 'news'" prop="tuwen_name">
                        <el-button size="small" @click="optuwen" type="primary">选择文章</el-button>
                        <div>{{editformValidate.tuwen_name?editformValidate.tuwen_name:'未选择'}}</div>
                    </el-form-item>
                    <el-form-item label="消息：" v-if="editformValidate.type == 'sketch'">
                        <el-form-item :label="'消息'+(i+1)" required v-for="(c,i) in editformValidate.rwb_contents"
                            :key="i" label-width="70px">
                            <div class="con_s">
                                <el-input v-model="c.content" placeholder="请填写消息内容" type="textarea"
                                    style="max-width:400px" :rows="4" size="small"></el-input>
                                <div class="con_a_btn">
                                    <el-button @click="del_cons(i)" v-if="i>0" size="small"
                                        icon="el-icon-remove-outline" circle></el-button>
                                    <el-button @click="add_cons()" size="small" type="primary"
                                        icon="el-icon-circle-plus-outline" circle>
                                    </el-button>
                                </div>
                            </div>
                        </el-form-item>
                    </el-form-item>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="submit('editformValidate')" size="small" type="primary" :loading="subloading">提 交
                </el-button>
                <el-button @click="dialog_edit = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
        <el-dialog title="选择图文" center :visible.sync="dialog_tuwen" width="60%" top="80px" class="dialogs">
            <el-divider></el-divider>
            <tuwen @selecttuwen="selects" />
            <el-divider></el-divider>

        </el-dialog>
        <el-dialog title="优惠券设置" :visible.sync="dialogTableVisible" width="80%" top="20px">
            <activity ref="yhq"></activity>
        </el-dialog>
    </div>
</template>

<script>
    // import { keywordListApi, keywordsetStatusApi, downloadReplyCode } from '@/api/app'
    import {
        mapState
    } from 'vuex'
    import activity from "../../views/publicAccount/lygactivity/index.vue";
    import tuwen from "./tuwen.vue";
    export default {
        inject: ['app'],
        name: 'keyword',
        components: {
            tuwen,
            activity,
        },
        data() {
            const validateContent = (rule, value, callback) => {
                if (this.formValidate.type === 'text') {
                    if (this.formValidate.data.content === '') {
                        callback(new Error('请填写规则内容'))
                    } else {
                        callback()
                    }
                }
            }
            return {
                heights: null,
                tw_heights: null,
                loading: false,
                formValidate: {
                    key: '',
                    type: '',
                    page: 1,
                    limit: 15
                },
                editformValidate: {
                    name: '',
                    status: 0,
                    type: '',
                    content: '',
                    image_url2: '',
                    image_url: '',
                    tuwen_name: '',
                    tuwen_id: '',
                    count: 1,
                    rwb_contents: [{
                        content: ''
                    }]
                },
                ruleValidate: {
                    name: [{
                        required: true,
                        message: '请填写关键字',
                    }],
                    type: [{
                        required: true,
                        message: '请选择消息类型',
                        trigger: 'change'
                    }],
                    content: [{
                        required: true,
                        message: '请填写内容',
                        trigger: 'blur'
                    }],
                    image_url: [{
                        required: true,
                        message: '请选择图片',
                        trigger: 'blur'
                    }],
                    tuwen_name: [{
                        required: true,
                        message: '请选择文章',
                        trigger: 'blur'
                    }],
                    count: [{
                        required: true,
                        message: '请输入人数',
                        trigger: 'blur'
                    }],
                },
                tabList: [],
                total: 0,
                columns1: [{
                        title: 'ID',
                        key: 'id',
                        width: 80
                    },
                    {
                        title: '关键字',
                        key: 'key',
                        minWidth: 120
                    },
                    {
                        title: '回复类型',
                        key: 'type',
                        minWidth: 150
                    },
                    {
                        title: '是否显示',
                        slot: 'status',
                        minWidth: 120
                    },
                    {
                        title: '操作',
                        slot: 'action',
                        fixed: 'right',
                        minWidth: 120
                    }
                ],
                // modal: false,
                // qrcode: ''
                gzh_value: '',
                gzh_options: [],
                gzh_appid: '',
                dialog_edit: false,
                subloading: false,
                openeditloading: false,
                eid: 0,
                dialog_tuwen: false,
                dialogTableVisible: false,
            }
        },
        mounted() {
            this.getselects()
            this.getHeight()

        },
        computed: {},
        methods: {
            changetype(a) {
                this.editformValidate.content = ''
                this.editformValidate.rwb_contents = [{
                    content: ''
                }]
            },
            setUp(row) {
                this.dialogTableVisible = true;
                this.$nextTick(() => {
                    this.$refs.yhq.eid = row.id;
                    this.$refs.yhq.begin(row.id);
                    // this.$refs.votelist.votelist=row.content
                });
            },
            // 获取下拉框
            getselects() {
                axios.post('/admin/wechat.index/gzhConfig', {}, {
                    token: true
                }).then(res => {
                    if (res.data.data) {
                        this.gzh_options = res.data.data.filter(a=>a.appid!='wx10dde7d68a3a2239')
                        this.gzh_value = res.data.data[0].source
                        this.gzh_appid = res.data.data[0].appid
                        this.getList()
                    } else {
                        this.gzh_options = []
                    }
                }).catch(err => {})
            },
            changegzh(index) {
                this.gzh_options.forEach(ele => {
                    if (ele.source == index) {
                        this.gzh_appid = ele.appid
                    }
                })
            },

            getHeight() {
                let that = this
                var titles = that.$refs.titles.offsetHeight
                that.heights = window.innerHeight - titles - 230 + 'px'
                that.tw_heights = window.innerHeight - 300 + 'px'
                window.onresize = () => {
                    var titles = that.$refs.titles.offsetHeight
                    that.heights = window.innerHeight - titles - 230 + 'px'
                    that.tw_heights = window.innerHeight - 300 + 'px'
                }
            },
            begin() {
                this.formValidate.page = 1
                this.formValidate.limit = 15
                this.getList()
            },
            // 列表
            getList() {
                this.loading = true
                axios
                    .post(`/admin/pc/reply/index`, {
                        page: this.formValidate.page,
                        page_count: this.formValidate.limit,
                        source: this.gzh_value,
                        title: this.formValidate.key,
                        appid: this.gzh_appid
                    }, {
                        token: true
                    })
                    .then(response => {
                        let data = response.data
                        this.tabList = data.data.data
                        this.total = data.data.count
                        this.loading = false
                        this.tabList.forEach(element => {
                            element.status = element.status.toString()
                        });
                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.formValidate.limit = val;
                that.getList()
            },
            handleCurrentChange(val) {
                let that = this
                that.formValidate.page = val;
                that.getList()
            },
            // 修改是否显示
            onchangeIsShow(row) {
                let data = {
                    id: row.id,
                    value: row.status,
                    name: "status",
                    source: this.gzh_value,
                    appid: this.gzh_appid

                }
                axios
                    .post(`/admin/pc/reply/field`, data, {
                        token: true
                    })
                    .then(response => {
                        if (response.data.code == 200) {
                            this.getList()
                            this.$message({
                                type: "success",
                                message: "修改成功"
                            })
                        } else {
                            this.$message({
                                type: "error",
                                message: response.data.msg
                            })
                        }

                    })
                    .catch(error => {})
            },
            pos_chooseImage() {
                this.app.chooseImage((res) => {
                    this.editformValidate.image_url = res[0].url
                    this.editformValidate.image_url2 = res[0].local_url
                }, 1, '', '', 1, 'gzhkey')
            },
            optuwen() {
                this.dialog_tuwen = true
            },
            selects(o) {
                this.editformValidate.tuwen_name = o.name
                this.editformValidate.tuwen_id = o.id
                this.dialog_tuwen = false
            },
            submit(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (this.editformValidate.type == 'sketch') {
                            let a = 0
                            for (let i = 0; i < this.editformValidate.rwb_contents.length; i++) {
                                const e = this.editformValidate.rwb_contents[i];
                                if (e.content == '') {
                                    a = 1
                                    break
                                }
                            }
                            if (a == 1) return this.$message('消息未填写完整！')
                        }
                        that.subloading = true
                        let urls = "/admin/pc/reply/editor"
                        axios.post(urls, {
                                id: this.eid,
                                keys: this.editformValidate.name,
                                status: this.editformValidate.status,
                                type: this.editformValidate.type,
                                content: this.editformValidate.type == 'sketch' ? this.editformValidate
                                    .rwb_contents : this.editformValidate.content,
                                image_url: this.editformValidate.image_url2,
                                file: '',
                                op: "edit",
                                source: this.gzh_value,
                                appid: this.gzh_appid,
                                news_id: this.editformValidate.tuwen_id,
                                count: this.editformValidate.count - 0,

                            }, {
                                token: true
                            })
                            .then(response => {
                                that.subloading = false
                                if (response.data.code == '200') {
                                    that.dialog_edit = false
                                    that.getList()
                                } else {
                                    that.$message.error(response.data.msg);
                                }
                            })
                            .catch(error => {
                                that.subloading = true
                            })
                    } else {
                        this.$alert("信息遗漏未填")
                        return false;
                    }
                });
            },
            // 添加
            add() {
                this.eid = 0
                this.clear_f()
                this.dialog_edit = true

            },
            clear_f() {
                this.editformValidate = {
                    name: '',
                    status: 0,
                    count: 1,
                    type: '',
                    content: '',
                    image_url2: '',
                    image_url: '',
                    tuwen_name: '',
                    tuwen_id: '',
                    rwb_contents: [{
                        content: ''
                    }]
                }
            },
            // 编辑
            edit(row) {
                let that = this
                this.clear_f()
                this.eid = row.id
                this.dialog_edit = true
                this.openeditloading = true
                let urls = "/admin/pc/reply/editor"
                axios.post(urls, {
                        id: row.id,
                        source: this.gzh_value,
                        appid: this.gzh_appid
                    }, {
                        token: true
                    })
                    .then(res => {
                        let rows = res.data.data.data
                        if (res.data.code == '200') {

                            this.editformValidate.tuwen_name = rows.news_title
                            this.editformValidate.tuwen_id = rows.news_id
                            this.editformValidate.type = rows.type
                            if (rows.type == 'sketch') {
                                this.editformValidate.rwb_contents = rows.content
                            } else {
                                this.editformValidate.content = rows.content
                            }
                            this.editformValidate.image_url2 = rows.image_url
                            this.editformValidate.image_url = rows.url
                            this.editformValidate.status = rows.status - 0
                            this.editformValidate.name = rows.keys
                            this.editformValidate.count = rows.count ? rows.count : 0
                        } else {
                            that.$message.error(res.data.msg);
                        }
                        this.openeditloading = false
                    })
                    .catch(error => {
                        that.openeditloading = true
                    })

            },
            del(row) {
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios
                        .post(`/admin/pc/reply/delete`, {
                            id: row.id,
                            source: this.gzh_value,
                            appid: this.gzh_appid

                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == 200) {
                                this.getList()
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                            } else {
                                this.$message({
                                    type: "error",
                                    message: response.data.msg
                                })
                            }
                        })
                        .catch(error => {})

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });

            },
            add_cons() {
                this.editformValidate.rwb_contents.push({
                    content: ''
                })
            },
            del_cons(i) {
                this.editformValidate.rwb_contents.splice(i, 1)
            }
        }
    }
</script>

<style scoped>
    .QRpic {
        width: 180px;
        height: 180px;
    }

    .QRpic img {
        width: 100%;
        height: 100%;
    }

    .con_s {
        /* display: flex;
        align-items: flex-end; */
    }

    .con_a_btn {
        margin-top: 5px;
        max-width: 400px;
        display: flex;
        justify-content: flex-end;
    }
</style>